__turbopack_context__.v({
  "contributors": "_9tpGKa_contributors",
  "contributors__list": "_9tpGKa_contributors__list",
  "contributors__title": "_9tpGKa_contributors__title",
});
